import * as React from 'react'
import { ApiCustomer } from '@vend/types'
import { useT } from '@transifex/react'
import { CONTACT_OPTIONS, CustomerInfo } from './types'

interface Props {
  customer: CustomerInfo | ApiCustomer | null
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  defaultOption: CONTACT_OPTIONS
}

const getContactNumber = (
  customer: CustomerInfo | ApiCustomer | null,
  option: CONTACT_OPTIONS
) => {
  if (customer) {
    return customer![option]
  }
  return ''
}

export const ContactNumber: React.FC<Props> = ({
  customer,
  onChange,
  defaultOption,
}) => {
  const [contactOption, setContactOption] = React.useState<CONTACT_OPTIONS>(
    defaultOption
  )
  const [contactNumber, setContactNumber] = React.useState(
    getContactNumber(customer, defaultOption)
  )

  const t = useT()

  return (
    <div className="vd-value">
      <div className="vd-select-group">
        <select
          className="vd-select"
          defaultValue={defaultOption}
          onChange={e => {
            setContactOption(e.currentTarget.value as CONTACT_OPTIONS)
            setContactNumber(
              getContactNumber(
                customer,
                e.currentTarget.value as CONTACT_OPTIONS
              )
            )
          }}
        >
          <option label="Mobile" value={CONTACT_OPTIONS.MOBILE}>
            Mobile
          </option>
          <option label="Phone" value={CONTACT_OPTIONS.PHONE}>
            Phone
          </option>
          <option label="Fax" value={CONTACT_OPTIONS.FAX}>
            Fax
          </option>
        </select>
        <input
          className="vd-input"
          placeholder={t('Enter number', {
            _context: `Input placeholder text for Contact Number input`,
          })}
          type="tel"
          name={contactOption}
          value={contactNumber || ''}
          onChange={e => {
            setContactNumber(e.currentTarget.value)
            onChange(e)
          }}
        />
      </div>
    </div>
  )
}
